import Feature23 from './Feature23'
export default Feature23
